import { aesEncryptAsync, aesDecryptAsync, AESSealedData } from "@-/com.npmjs.expo-crypto";
import { getBackupKey } from "#backup-key";
export async function sealBackup(value: string, key: string): Promise<string> {
  const sealed = await aesEncryptAsync(new TextEncoder().encode(value), await getBackupKey(), {
    additionalData: new TextEncoder().encode(key),
  });
  return sealed.combined("base64");
}
export async function unsealBackup(value: string, key: string): Promise<string> {
  return new TextDecoder().decode(
    await aesDecryptAsync(AESSealedData.fromCombined(value), await getBackupKey(), {
      additionalData: new TextEncoder().encode(key),
    }),
  );
}
